import { Action } from '@ngrx/store';
import { Locale, UserPreference } from '@rd/types';

// We update preferences one by one since we don't do batch updates to user preferences
// Example, we don't update locale and points account ID at the same time
export enum UserPreferenceActionTypes {
  UPDATE_POINTS_ACCOUNT_ID = '[UserPreference] Update points account id',
  UPDATE_POINTS_ACCOUNT_ID_SUCCESS = '[UserPreference] Update points account id success',
  UPDATE_POINTS_ACCOUNT_ID_FAIL = '[UserPreference] Update user preference fail',
  UPDATE_LOCALE = '[UserPreference] Update locale',
  UPDATE_LOCALE_SUCCESS = '[UserPreference] Update locale success',
  UPDATE_LOCALE_FAIL = '[UserPreference] Update locale fail',
  INITIALISE_USER_PREFERENCES = '[UserPreference] Initialise User Preferences',

  // Local locale
  UPDATE_LOCAL_STORAGE_LOCALE = '[UserPreference] Update local storage locale',
  RELOAD_LOCAL_STORAGE_LOCALE = '[UserPreference] Reload local storage locale',
}

export class UpdateLocale implements Action {
  readonly type = UserPreferenceActionTypes.UPDATE_LOCALE;

  constructor(public payload: Locale) {}
}

export class UpdateLocaleSuccess implements Action {
  readonly type = UserPreferenceActionTypes.UPDATE_LOCALE_SUCCESS;

  constructor(public payload: Locale) {}
}

export class UpdateLocaleFail implements Action {
  readonly type = UserPreferenceActionTypes.UPDATE_LOCALE_FAIL;
}

export class UpdatePointsAccountId implements Action {
  readonly type = UserPreferenceActionTypes.UPDATE_POINTS_ACCOUNT_ID;

  constructor(public payload: string) {}
}

export class UpdatePointsAccountIdSuccess implements Action {
  readonly type = UserPreferenceActionTypes.UPDATE_POINTS_ACCOUNT_ID_SUCCESS;

  constructor(public payload: string) {}
}

export class UpdatePointsAccountIdFail implements Action {
  readonly type = UserPreferenceActionTypes.UPDATE_POINTS_ACCOUNT_ID_FAIL;
}

export class InitialiseUserPreferences implements Action {
  readonly type = UserPreferenceActionTypes.INITIALISE_USER_PREFERENCES;

  constructor(public payload: UserPreference) {}
}

export class UpdateLocalLocale implements Action {
  readonly type = UserPreferenceActionTypes.UPDATE_LOCAL_STORAGE_LOCALE;

  constructor(public payload: Locale) {}
}

export class RestoreLocalLocale implements Action {
  readonly type = UserPreferenceActionTypes.RELOAD_LOCAL_STORAGE_LOCALE;

  constructor(public payload: Locale) {}
}

export type UserPreferenceAction =
  | UpdateLocale
  | UpdateLocaleSuccess
  | UpdateLocaleFail
  | UpdatePointsAccountIdSuccess
  | UpdatePointsAccountIdFail
  | InitialiseUserPreferences
  | UpdateLocalLocale
  | RestoreLocalLocale;
